'use client';

import { useGa4UserId } from '@hooks/analytics/useGa4UserId';

/**
 * @description Mounts listeners that keep GA4 user_id in sync via GTM (through dataLayer auth_state and sign_up events).
 */
export const Ga4UserLinker = () => {
  useGa4UserId();
  return null;
};
